<template>
    <div>
        <div :class="unica ? '' : 'card dashcard mb-0'">
            <div :class="unica ? '' : 'card-body'">
                <div class="form-row">
                    <div class="col col-12" :class="unica ? 'col-md-3' : 'col-md-2'">
                        <az-input
                            type="date"
                            v-model="referencia">       
                            <template v-slot:button-pre>
                                <div class="input-group-prepend">
                                    <button type="button" class="btn btn-outline-primary" @click="load()" 
                                        :disabled="$store.state.loading" id="refresh-button">
                                        <i class="fas fa-sync-alt fa-fw"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>

                    <template v-if="!unica">
                        <div class="col col-12 col-md-2">
                            <div class="input-group mb-1">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-building fa-fw" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <select class="form form-control" v-model="filtro.id_unidade_operacao">
                                    <option value="">Unidades...</option>
                                    <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                        :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col col-12 col-md-4">
                            <az-input
                                icon="fa fa-filter fa-fw"
                                type="select"
                                :optionsList="filas.map(item => { return { id: item.id_fila_laudo, search: item.search } })"
                                optionsData="id"
                                optionsDisplay="search"
                                v-model="filtro.id_fila_laudo"
                                :edicao="!$store.state.loading"
                                @input="load()" />
                        </div>
                        <div class="col col-12 col-md-4">
                            <az-input icon="fas fa-user-md fa-fw" 
                                type="select" 
                                placeholder="Todos os Médicos..."
                                optionsMode="aql"
                                service="medicos.index"
                                optionsName="medicos-cadastro"
                                :optionsParm="{ ativos: true }"
                                optionsData="id_pessoa"
                                v-model="filtro.id_medico" />
                        </div> 
                    </template>
                </div>

                <div class="form-row mt-2" v-if="!unica">
                    <div class="col col-12 col-md-4">
                        <az-input 
                            icon="fa-solid fa-user-injured fa-fw"
                            placeholder="Selecionar paciente..."
                            type="autocomplete" 
                            optionsMode="aql"
                            service="pacientes.index"
                            optionsDisplay="search"
                            ref="paciente"
                            v-model="filtro.paciente" 
                            :optimized_ac="true" />
                    </div>
                    
                    <div class="col col-12" :class="is_fila_intern ? 'col-md-4' : 'col-md-8'">
                        <az-input
                            icon="fa fa-search"
                            v-model="search" />       
                    </div>

                    <div v-if="is_fila_intern" class="col col-12 col-md-4">
                        <az-input 
                            placeholder="Unidade de Internação..."
                            icon="fa-solid fa-bed fa-fw"
                            type="select"
                            optionsMode="aql"
                            :optionsName="'centro_custos.index.leito.' + filtro.id_unidade_operacao"
                            service="centro_custos.index"
                            optionsData="id_centro_custo" 
                            optionsDisplay="st_nome"
                            :optionsParm="{ 
                                ativos: true,
                                id_unidade_operacao: filtro.id_unidade_operacao,
                                leitos: true, 
                            }"
                            v-model="filtro.id_centro_custo"  />
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>

        <az-empty-state v-if="!lista.length" />

        <table class="table bg-white">
            <tbody>
                <template v-for="(receita, index) in lista">
                    <tr :key="'P' + index" v-if="true">
                        <td colspan="3">
                            <div class="row">
                                <div class="col col-12 col-md-4">
                                    <div>
                                        <a href="#" @click.prevent="receita.exibido = !receita.exibido" class="card-link">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                        </a>
                                        <small class="text-muted">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.sexo }},
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }}
                                        </small>
                                    </div>
                                    <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.plano.search }}</div>
                                    <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.medico.search }}</div>
                                </div>
                                <div class="col col-12 col-md-2">
                                    <div v-if="receita.internacao && receita.internacao.local" title="Internação / Leito">
                                        <div>
                                            <span class="small text-muted">
                                                {{ receita.internacao.local.centro_custo.st_nome }}
                                            </span>
                                        </div>
                                        <div>
                                            <span class="small">
                                                {{ receita.internacao.local.st_local }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-4">
                                    <!-- Status da Prescrição -->
                                    <div v-if="receita.contato">
                                        <span class="badge" :class="'badge-' + cor_contato(receita)">
                                            {{ receita.contato.contato_status.search }}
                                            / {{ quando(receita.contato.created_at) }}
                                        </span> 
                                    </div>

                                    <div class="small mb-2" v-if="receita.anamnese.atendimento_procedimento.procedimento">
                                        <div>{{ receita.anamnese.atendimento_procedimento.procedimento.search }}</div>
                                        <div v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.st_titulo }}
                                        </div>
                                        <div class="text-muted">#{{ receita.anamnese.atendimento_procedimento.id_atendimento }}</div>

                                        <div class="text-muted" v-if="receita.dt_valid_ini && receita.dt_valid_fim">
                                            {{ $util.getFormatDate(receita.dt_valid_ini, 'DD/MM') }} {{ receita.dt_valid_ini.slice(11,16) }}
                                            - {{ $util.getFormatDate(receita.dt_valid_fim, 'DD/MM') }} {{ receita.dt_valid_fim.slice(11,16) }}
                                        </div>

                                        <div class="text-muted" v-else-if="receita.anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento == 7 && receita.in_duracao > 1">
                                            {{ $util.getFormatDate(receita.dt_referencia) }}, {{ receita.in_duracao }} dias
                                        </div>
                                    </div>
                                </div>
                                <div class="col col-12 col-md-2 text-right">
                                    <template v-if="receita.exibido">

                                        <div v-if="receita.fl_suspensa" class="text-right mb-1">
                                            <span class="badge badge-danger">
                                                Suspensa
                                            </span>
                                        </div>
                                       
                                        <az-submit v-if="receita.prescricao_certificado" @click="abrir_modal_documentos(receita)" title="Visualizar documentos assinados" data-toggle="tooltip" color="outline-primary btn-sm" class="mr-1">
                                            <i class="fa-solid fa-file-contract"></i>
                                        </az-submit>
                                        <az-submit color="outline-success btn-sm" @click="evolucao(receita)"  class="mr-1" title="Evolução">
                                            <i class="fa-solid fa-comment-medical"></i>
                                        </az-submit>
                                        <az-submit v-if="!receita.fl_suspensa && pode_assinar(receita)" title="Assinar" color="outline-success btn-sm" @click="assinar(receita)" class="mr-1">
                                            <i class="fas fa-signature"></i>
                                        </az-submit>
                                        <az-submit color="outline-success btn-sm" title="Impirmir" @click="imprimirPrescricao(receita)" class="mr-1" v-if="!receita.fl_suspensa">
                                            <i class="fas fa-print" aria-hidden="true" ></i>
                                        </az-submit>
                                        <az-submit color="outline-success btn-sm" @click="checar(receita)" v-if="!receita.fl_suspensa">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </az-submit>
                                        <button type="button" class="btn btn-outline-secondary btn-sm ml-1" title="Checagem por Bipagem" @click="toggle_bipagem(receita)">
                                            <i class="fa-solid fa-barcode"></i>
                                        </button>
                                        
                                    </template>

                                    <template v-else>
                                        <div v-if="receita.fl_suspensa" class="text-right">
                                            <span class="badge badge-danger">
                                                Suspensa
                                            </span>
                                        </div>

                                        <div v-else>
                                            <div class="dropleft">
                                                <a href="#" id="dropdownMenuButton" data-toggle="dropdown" class="alert-link mb-2" :class="receita.solicitacao ? 'text-success' : 'text-secondary'" title="Solicitar Mat/Med." @click.prevent>
                                                    <i class="fa-solid fa-boxes-packing"></i>
                                                </a>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" @click.prevent="solicitar_matmed(receita, true)">Nova Solicitação</a>
                                                    <a class="dropdown-item" href="#" @click.prevent="solicitar_matmed(receita)" v-if="receita.solicitacao">Acessar Solicitação</a>
                                                </div>
                                            </div>

                                            <a v-if="false" href="#" class="alert-link mb-2" :class="receita.solicitacao ? 'text-success' : 'text-secondary'" title="Solicitar Mat/Med." @click.prevent="solicitar_matmed(receita)">
                                                <i class="fa-solid fa-boxes-packing"></i>
                                            </a>
                                        </div>

                                        <h5 v-for="(items, status, irx) in stat_horarios(receita)" :key="irx">
                                            <span class="badge badge-secondary" v-if="status == 'A'">
                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-success" v-if="status == 'X'">
                                                <i class="fa fa-check-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-warning" v-if="status == 'R'">
                                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-danger" v-if="status == 'C'">
                                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                        </h5>
                                    </template>
                                </div>
                            </div>

                            <div class="d-flex justify-content-between" v-if="false">
                                <div>
                                    <div>
                                        <a href="#" @click.prevent="receita.exibido = !receita.exibido" class="card-link">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome }}
                                        </a>
                                        <small class="text-muted">
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.sexo }},
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.paciente.cadastro.idade }}
                                        </small>
                                    </div>
                                    <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.plano.search }}</div>
                                    <div class="small">{{ receita.anamnese.atendimento_procedimento.atendimento.medico.search }}</div>
                                </div>
                                <div class="text-right">
                                    <div class="small mb-2" v-if="receita.anamnese.atendimento_procedimento.procedimento">
                                        #{{ receita.anamnese.atendimento_procedimento.id_atendimento }}
                                        <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                        {{ receita.anamnese.atendimento_procedimento.procedimento.search }}
                                        <template v-if="receita.anamnese.atendimento_procedimento.atendimento.marcacao && receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ receita.anamnese.atendimento_procedimento.atendimento.marcacao.infusao.st_titulo }}
                                        </template>
                                    </div>
                                    
                                    <template v-if="receita.exibido">
                                        <az-submit color="outline-success btn-sm" @click="checar(receita)">
                                            <i class="fa fa-check" aria-hidden="true"></i>
                                        </az-submit>
                                    </template>
                                    <template v-else>
                                        <h5 v-for="(items, status, irx) in stat_horarios(receita)" :key="irx">
                                            <span class="badge badge-secondary" v-if="status == 'A'">
                                                <i class="fa fa-question-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-success" v-if="status == 'X'">
                                                <i class="fa fa-check-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-warning" v-if="status == 'R'">
                                                <i class="fa fa-exclamation-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                            <span class="badge badge-danger" v-if="status == 'C'">
                                                <i class="fa fa-times-circle" aria-hidden="true"></i>
                                                <span class="ml-2">{{ items.length }}</span>
                                            </span>
                                        </h5>
                                    </template>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <template v-if="receita.exibido">

                        <!-- Leitura de Bipagem -->
                        <template v-if="receita.bipagem">
                            <tr :key="'BP' + index">
                                <td colspan="2" class="py-1">
                                    <az-input
                                        placeholder="Horário"
                                        sizing="sm"
                                        type="select"
                                        :optionsList="lista_horarios(receita)"
                                        optionsData="id"
                                        v-model="receita.horario" />
                                </td>
                                <td class="py-1">
                                    <selecao-material 
                                        v-if="receita.horario"
                                        :barcode_only="true" 
                                        @selecionado="selecionar_aplicacao_por_bipagem(receita, $event)" />
                                </td>   
                                
                            </tr>
                        </template>

                        <!-- Itens da Prescrição -->
                        <template v-for="(medic, imx) in receita.items">
                            <tr class="table-danger" :key="'A' + index + 'M' + imx" v-if="receita.anamnese && receita.anamnese.atendimento_procedimento && receita.anamnese.atendimento_procedimento.atendimento && receita.anamnese.atendimento_procedimento.atendimento.paciente && receita.anamnese.atendimento_procedimento.atendimento.paciente.alergias && receita.anamnese.atendimento_procedimento.atendimento.paciente.alergias.length">
                                <td colspan="3" class="py-1">
                                    <div class="small" v-for="(alergia, iax) in receita.anamnese.atendimento_procedimento.atendimento.paciente.alergias" :key="iax">
                                        <span class="mr-2" v-if="!iax">Alergias:</span>
                                        <strong>{{ alergia.tipo.search }}</strong>
                                        <template v-if="alergia.st_observacoes">
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>{{ alergia.st_observacoes }}
                                        </template>
                                    </div>
                               </td>
                            </tr>
                            <tr :key="'P' + index + 'M' + imx" v-if="!medic.block_d">
                                <td class="text-center" width="2%">
                                    <az-audit-log-button model="receitaMedicamento" :id="medic.id_receita_medicamento" sizing="sm" />
                                    
                                    <div class="mt-1 text-center">
                                        <a href="#" @click.prevent="toggle_medic_suspenso(medic)" title="Suspender medicação" v-if="!medic.fl_suspenso" data-toggle="tooltip" data-placement="top">
                                            <i class="fa fa-ban text-secondary" aria-hidden="true"></i>
                                        </a>

                                        <a href="#" @click.prevent="toggle_medic_suspenso(medic)" title="Reativar medicação" v-else data-toggle="tooltip" data-placement="top">
                                            <i class="fa fa-ban text-danger" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </td>
                                <td>
                                    <div v-if="medic.diluidos && medic.diluidos.length">
                                        <div v-for="(diluido, idx) in medic.diluidos" :key="idx" class="mt-0">
                                            <table class="table table-sm table-borderless p-0 mb-0" v-if="!diluido.block_d">
                                                <tr>
                                                    <td width="1%"><i class="fa fa-plus fa-fw mr-1" aria-hidden="true"></i></td>
                                                    <td>
                                                        {{ diluido.item.st_medicamento }}
                                                        <div class="text-muted" v-if="diluido.quantidade">
                                                            {{ diluido.quantidade }}
                                                            <span v-if="diluido.qtd_calc">
                                                                <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                                <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                                            </span>
                                                        </div>

                                                        <div class="text-muted" v-if="diluido.st_posologia">
                                                            {{ diluido.st_posologia }}
                                                        </div>

                                                        <div v-if="medic.st_observacoes" class="text-muted">
                                                            {{ medic.st_observacoes }}
                                                        </div>
                                                    </td>
                                                </tr>
                                                <tr v-if="false">
                                                    <td></td>
                                                    <td class="text-muted">
                                                        {{ diluido.quantidade }}
                                                        <span v-if="diluido.qtd_calc">
                                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                                            <strong class="text-muted">{{ diluido.qtd_calc }}</strong>
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr v-if="false">
                                                    <td></td>
                                                    <td class="text-muted">{{ diluido.st_posologia }}</td>
                                                </tr>
                                                <tr v-if="false && medic.st_observacoes">
                                                    <td></td>
                                                    <td class="text-muted">{{ medic.st_observacoes }}</td>
                                                </tr>
                                            </table>
                                        </div>
                                    </div>

                                    <div :class="( medic.diluidos && medic.diluidos.length ) ? 'small' : ''">
                                        <div>{{ medic.item.st_medicamento }}</div>
                                        <info-suspenso :medic="medic" />
                                        <span class="text-muted">{{ medic.quantidade }}</span>
                                        <span class="text-muted" v-html="medic.complemento"></span>
                                        <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>
                                    </div>
                                </td>
                                <td style="width: 50%;">
                                    <div v-for="(horario, ihx) in medic.js_prescricao_horarios.horarios" :key="ihx">

                                        <template v-if="!receita.bipagem || !receita.horario || ( receita.horario == horario.hora )">

                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend input-group-sm">
                                                    <span class="input-group-text" id="basic-addon1" v-if="!( dados && dados.livre )">
                                                        {{ horario.hora && horario.hora.length > 10 ? $util.getFormatDate(horario.hora) + ' ' + horario.hora.slice(11, 16) : horario.hora }}
                                                    </span>
                                                </div>
                                                <template v-if="possibilidade_dupla_checagem(horario)">
                                                    <div class="input-group-prepend">
                                                        <button @click="dupla_checagem(horario)" title="Dupla Checagem"
                                                            class="btn btn-sm btn-outline-success px-1" type="button">
                                                        <i class="fas fa-check-double mx-1"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                                <template v-if="dados && dados.livre">
                                                    <div class="input-group-prepend input-group-sm">
                                                        <button class="btn btn-sm btn-outline-secondary px-1" type="button"
                                                            id="button-addon2" data-toggle="tooltip" data-placement="top"
                                                            title="Copiar para os demais items."
                                                            :disabled="$store.state.loading"
                                                            @click="copiar_checagem(receita, horario)">
                                                        <i class="fas fa-arrows-alt-v"></i>
                                                        </button>
                                                    </div>
                                                    <input :type="tem_duracao(receita, horario.hora) ? 'datetime-local' : 'time'" v-model="horario.hora" class="form-control" />
                                                </template>
                                                <label v-if="horario.status == 'S'" class="form-control form-control-sm text-danger">Suspenso</label>
                                                <template v-else>
                                                    <label v-if="horario.status == 'Z'" class="form-control form-control-sm text-danger">Reaprazado</label>

                                                    <select name="" id="" v-else class="form-control form-control-sm" @change="alterar_responsavel(horario)" v-model="horario.status" :disabled="( receita.bipagem && !receita.horario ) || ( horario.hora && ( horario.hora.length > 10 ) && tolerancia_excedida(horario) )">
                                                        <option value="A">Aberto</option>
                                                        <option value="X">Checado</option>
                                                        <option value="R">Rejeitado</option>
                                                        <option value="C">Cancelado</option>
                                                    </select>
                                                    
                                                    <template v-if="( horario.status == 'A' && horario.hora && ( horario.hora.length > 10 ) && tolerancia_excedida(horario) )">
                                                        <label class="form-control form-control-sm">
                                                            <a href="#" class="card-link" @click.prevent="iniciar_reaprazar(medic, horario, ihx)">Reaprazar</a>
                                                        </label>
                                                    </template>

                                                    <input v-else type="text" class="form-control form-control-sm" v-model="horario.obs" :disabled="horario.status == 'S' || horario.status == 'Z'" placeholder="Obs..." />

                                                    <div class="input-group-append input-group-sm" v-if="horario.status">
                                                        <span v-if="horario.responsavel_atualizacao" class="input-group-text"
                                                            id="basic-addon2">
                                                            por
                                                            <template v-if="!Array.isArray(horario.responsavel_atualizacao)">
                                                                {{ $util.ucwords(horario.responsavel_atualizacao) }}
                                                            </template>
                                                            <template v-else
                                                                v-for="(responsavel, index) in horario.responsavel_atualizacao">
                                                                {{ index > 0 ? ' e ' : '' }}{{
                                                                $util.ucwords(responsavel.st_nome) }}

                                                                <span v-if="responsavel.conselho && responsavel.numero" :key="'c' + index" class="small text-muted ml-1" :title="responsavel.conselho + ' ' + responsavel.numero">
                                                                    {{ responsavel.conselho }}
                                                                </span>
                                                            </template>
                                                        </span>
                                                        <span class="input-group-text" id="basic-addon2">
                                                            <az-float-panel :icon="cor_status(horario)"
                                                                :color="cor_float_panel(horario)" title="Status de Checagem"
                                                                iconOnly="true"
                                                                >
                                                                <div>
                                                                <p style="font-weight: bold;">{{ tratar_status(horario) }} por:</p>
                                                                <div v-if="!Array.isArray(horario.responsavel_atualizacao)">
                                                                    <span class="text-muted">{{ $util.ucwords(horario.responsavel_atualizacao) }}</span>
                                                                </div>
                                                                <div v-else>
                                                                    <div v-for="(responsavel, index) in horario.responsavel_atualizacao" :key="index">
                                                                        <div class="small">
                                                                            <span class="text-muted">{{ $util.ucwords(responsavel.st_nome) }}</span>
                                                                            <i class="fa fa-caret-right mx-1 text-muter"
                                                                                aria-hidden="true"></i>
                                                                            <span v-if="responsavel.dt_atualizacao">{{ formatar_dt_atualizacao(responsavel.dt_atualizacao) }}</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                </div>
                                                            </az-float-panel>
                                                        </span>
                                                    </div>
                                                </template>
                                            </div>

                                        </template>

                                    </div>

                                    <div class="mt-1 form-row" v-if="( medic.js_prescricao_horarios.horarios.length == 1 && medic.diluidos && medic.diluidos.length ) || ( medic.item && medic.item.fl_diluente )">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                type="time"
                                                label="Início"
                                                :compact="true"
                                                :validate="validate"
                                                v-model="medic.js_prescricao_horarios.inicio" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                type="time"
                                                label="Término"
                                                :compact="true"
                                                :validate="validate"
                                                v-model="medic.js_prescricao_horarios.fim" />
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <template v-if="receita.evolucoes && receita.evolucoes.length">
                            <tr v-for="(evolucao, iex) in receita.evolucoes" :key="iex" class="table-secondary">
                                <td class="text-center">
                                    <a href="#" @click.prevent="editar_evolucao(receita, evolucao)" class="card-link">
                                        <i class="fa-solid fa-comment-medical"></i>
                                    </a>
                                </td>
                                <td>
                                    <span class="small text-muted" v-if="evolucao.usuario">
                                        {{ evolucao.usuario.st_login }}, em {{ $util.getFormatDate(evolucao.created_at) }} {{ evolucao.created_at.slice(11,16) }}
                                        <span v-if="evolucao.created_at != evolucao.updated_at"> - Atualizado em {{ $util.getFormatDate(evolucao.updated_at) }} {{ evolucao.updated_at.slice(11,16) }}</span>
                                    </span>
                                </td>
                                <td>
                                    <span style="white-space: pre-wrap;">{{ evolucao.st_texto }}</span>
                                </td>
                            </tr>
                        </template>
                    </template>
                </template>
            </tbody>
        </table>

        <!-- Modal -->
        <div class="modal fade" id="aprazamentoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Aprazar: 
                            {{ item.anamnese.atendimento_procedimento.atendimento.paciente.search }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-hover">
                            <tr v-for="(medic, imx) in item.items" :key="imx">
                                <div class="row">
                                    <div class="col col-12 col-md-8">
                                        <div>{{ medic.item.st_medicamento }}</div>
                                        <div class="text-muted">{{ medic.quantidade }}</div>
                                        <div class="text-muted">{{ medic.st_posologia }}</div>
                                        <div class="small text-muted" v-if="medic.st_observacoes">{{ medic.st_observacoes }}</div>
                                    </div>
                                    <div class="col col-12 col-md-4">
                                        <div v-if="medic.js_prescricao_horarios">
                                            <div class="row no-gutters">
                                                <div class="col col-12 col-md-6" v-for="(horario, ihx) in medic.js_prescricao_horarios.horarios" :key="'M' + imx + '.H' + ihx">
                                                    <az-input
                                                        class="mr-1"
                                                        type="time"
                                                        required
                                                        :validate="validate"
                                                        v-model="horario.hora" />
                                                </div>
                                            </div>
                                        </div>

                                        <div class="btn-group" role="group" aria-label="Basic example">
                                            <div class="dropdown">
                                                <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                    {{ qtde }}
                                                </button>
                                                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                    <a class="dropdown-item" href="#" v-for="qtd in 6" @click.prevent="qtde = qtd" :key="qtd">
                                                        {{ qtd }}
                                                    </a>
                                                </div>
                                            </div>
                                            <button type="button" class="btn btn-primary btn-sm" @click="incluir_horario(medic)">
                                                <i class="fa fa-plus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </tr>
                        </table>

                        <br><br><br><br>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="salvar_aprazamento()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <pre v-if="false && dados" class="alert alert-warning mt-3">{{ dados }}</pre>
        <assinar-prescricao ref="assinador" />
        <arquivos icone="fas fa-signature mr-2" titulo="Prescrições Assinadas" ref="documentos"/>
        <evolucao-receita ref="evolucao" @refresh="load" />

        <!-- Reaprazamento -->
        <div class="modal fade" :id="modal_reaprazar" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Reaprazar Horário</h5>
                        <button type="button" class="close" @click="fechar_modal(modal_reaprazar)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body" v-if="reaprazamento">
                        <div class="alert alert-info">
                            {{ $util.getFormatDate(reaprazamento.horario.hora) }}
                            {{ reaprazamento.horario.hora.slice(11,16) }}
                        </div>

                        <az-input 
                            label="Novo Horário"
                            v-model="reaprazamento.novo_horario"
                            step="60"
                            type="datetime-local" />

                        <az-input 
                            label="Justificativa"
                            v-model="reaprazamento.obs"
                            rows="3"
                            type="textarea" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar_modal(modal_reaprazar)">Cancelar</button>
                        <button type="button" class="btn btn-primary" @click="confirmar_reaprazar()">Reaprazar</button>
                    </div>
                </div>
            </div>
        </div> 
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import AssinarPrescricao from '../consultorio/AssinarPrescricao.vue';
import Arquivos from '../../shared/Arquivos.vue';
import AzFloatPanel from '../../util/AzFloatPanel.vue';
import EvolucaoReceita from './EvolucaoReceita.vue';
import moment from 'moment';
import SelecaoMaterial from '../suprimentos/SelecaoMaterial.vue';
import InfoSuspenso from './InfoSuspenso.vue';

export default {
    data () { 
        return { 
            referencia: this.$util.hoje(), 
            search: "", 
            dados: null, 
            item: null, 
            qtde: 1, 
            validate: false, 
            filtro: { 
                id_unidade_operacao: this.$util.getCookie('id_unidade_operacao'),
                id_fila_laudo: "", 
                id_medico: "", 
                paciente: "", 
                id_centro_custo: "", 
            },
            filas: [],
            user: this.$store.state.user.pessoa,
            flDuplaChecagem: false,
            id_receita: null, 
            chave: "", 
            reaprazamento: null, 
        }
    },

    components: { 
        AzInput, 
        AzEmptyState, 
        AzSubmit, 
        AzAuditLogButton, 
        AssinarPrescricao,
        Arquivos,
        AzFloatPanel, 
        EvolucaoReceita,
        SelecaoMaterial,
        InfoSuspenso,
    },

    computed: { 
        is_fila_intern: function () { 
            return this.fila_selected && this.fila_selected.fl_fila_intern ? true : false;
        },

        fila_selected() { 
            return this.filas.find(f => f.id_fila_laudo == this.filtro.id_fila_laudo);
        },

        lista: function () { 
            if ( !this.dados )
                return [];

            return this.dados.lista;
        },
        
        modal_reaprazar: function () { 
            return 'reaprazarModal-' + this.chave;
        }
    },

    props: ['unica', 'dieta'],

    methods: { 
        confirmar_reaprazar () { 
            if ( !this.reaprazamento ) {
                return; 
            }

            if ( !this.reaprazamento.novo_horario ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Informe o horário do re-aprazamento.',
                    life: 5000
                });
                return; 
            }

            if ( !this.reaprazamento.obs ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Informe a justificativa do re-aprazamento.',
                    life: 5000
                });
                return; 
            }

            let novo = _.cloneDeep(this.reaprazamento.horario);
            novo.status = 'A'; 
            novo.hora = this.reaprazamento.novo_horario;
            novo.obs = ""; 
            
            if ( this.tolerancia_excedida (novo) ) { 
                this.$toast.add({ 
                    severity: 'error',
                    summary: 'Erro',
                    detail: 'Horário inválido.',
                    life: 5000
                });
                return; 
            }

            this.reaprazamento.horario.status = 'Z';
            this.reaprazamento.horario.obs = this.reaprazamento.obs;

            this.alterar_responsavel(novo);
            this.alterar_responsavel(this.reaprazamento.horario);

            this.reaprazamento.rm.js_prescricao_horarios.horarios.splice(this.reaprazamento.indice + 1, 0, novo);

            $('#' + this.modal_reaprazar).modal('hide');
        },

        iniciar_reaprazar (medic, horario, idx) { 
            this.reaprazamento = { 
                rm: medic, 
                horario: horario, 
                indice: idx, 
                novo_horario: this.$util.hoje_com_hora(),
                obs: "",  
            };

            $('#' + this.modal_reaprazar).modal('show');
        },

        fechar_modal(modal) { 
            $('#' + modal).modal('hide');
        },

        tolerancia_excedida (horario) { 
            if ( !this.dados || !this.dados.tol_check || !isNaN(this.dados.tol_check) ) { 

                // Verificar se a diferenca em minutos de horario.hora e a data/hora atual é maior do que this.dados.tol_check.

                const data1 = moment(horario.hora);
                const data2 = moment();
                const diferencaMinutos = Math.abs(data2.diff(data1, 'minutes'));

                if ( diferencaMinutos > this.dados.tol_check ) {
                    return true; 
                }

            }    

            return false; 
        }, 

        quando (data) { 
            if ( data && data.slice(0,10) == this.$util.hoje() ) { 
                return 'Hoje'
            } else { 
                return this.$util.getFormatDate(data, 'DD/MM');
            }
        },  
        
        cor_contato (receita) { 
            if ( receita && receita.contato && receita.valid_id_marcacao && receita.contato.id_marcacao != receita.valid_id_marcacao ) { 
                return 'light text-muted';
            }

            return ( receita && receita.contato && receita.contato.contato_status ) ? receita.contato.contato_status.st_color : 'secondary';
        },

        lista_horarios (receita) { 
            if ( !receita || !receita.items || !receita.items.length ) { 
                return [];
            }

            return _.uniqBy(
                    receita.items.flatMap(item => item.js_prescricao_horarios ? item.js_prescricao_horarios.horarios : [])
                        .map(horario => { 
                            return { 
                                id: horario.hora,
                                search: horario.hora.length > 5 
                                    ? this.$util.getFormatDate(horario.hora) + ' ' + horario.hora.slice(11, 16) 
                                    : horario.hora
                            }
                        })
                        .sort(),
                    'id'
                );
        },

        toggle_bipagem (receita) { 
            receita.horario = ""; 
            receita.bipagem = !receita.bipagem; 
        },

        selecionar_aplicacao_por_bipagem (receita, info) { 
            console.log('receita-bipagem', receita);
            console.log('info-bipagem', info);

            let rm = receita.items.find(item => item.id_medicamento == info.id_medicamento);

            if ( !rm ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Item não identificado na prescrição. \n' + info.search, 
                    life: 5000 
                });

                return; 
            }

            let horario = rm.js_prescricao_horarios.horarios.find(h => h.hora == receita.horario);

            if ( !horario ) { 
                this.$toast.add({ 
                    severity: 'error', 
                    summary: 'Atenção', 
                    detail: 'Item não identificado na prescrição no horário selecionado. \n' + info.search, 
                    life: 5000 
                });

                return; 
            }

            if ( horario.status == 'X' ) { 
                this.$toast.add({ 
                    severity: 'warn', 
                    summary: 'Atenção', 
                    detail: 'Horário já checado. \n' + info.search, 
                    life: 5000 
                });

                return; 
            }

            horario.status = 'X';

            let id_estoque_lote = info.info_lote ? info.info_lote.id_estoque_lote : null;

            if ( id_estoque_lote ) { 
                horario.id_estoque_lote = id_estoque_lote; 
                horario.vl = true; 
            }

            this.$toast.add({ 
                severity: 'success', 
                summary: 'Atenção', 
                detail: 'Checagem registrada. \n' + info.search, 
                life: 5000 
            });
        },

        toggle_medic_suspenso (medic) { 
            let motivo; 

            if ( medic.fl_suspenso ) { 
                if ( !confirm('Confirma reativar a medicação (' + medic.item.search + ')?') ) { 
                    return; 
                }
            } else { 

                motivo = prompt('Informe o motivo para suspender a medicação (' + medic.item.search + ')?');

                if ( !motivo )
                    return;
            }

            this.$util.atualizar(this, { 
                service: 'pep',
                func: 'suspender_medicamento',
                dados: { 
                    id_receita_medicamento: medic.id_receita_medicamento, 
                    fl_suspenso: !medic.fl_suspenso,
                    st_suspenso_obs: motivo,
                },
                toast: true,
                reload: true, 
                callback: res => { 
                    if ( res && ( res.id_receita_medicamento == medic.id_receita_medicamento ) ) {
                        medic.fl_suspenso = res.fl_suspenso; 
                    }

                    if ( this.unica ) { 
                        this.$emit('refresh');
                    }
                }
            });
        },

        carregar_receita (id_receita) { 
            this.id_receita = id_receita;
            this.load();
        },

        tem_duracao (receita, hora = '') { 
            if ( hora && hora.length <= 5 ) { 
                return false;
            }

            if ( receita.in_duracao > 1 && _.get(receita, 'anamnese.atendimento_procedimento.atendimento.id_tipo_atendimento') == 7 ) { 
                return true;
            }

            return false;
        },

        editar_evolucao (receita, evolucao) { 
            this.$refs.evolucao.editar(receita, evolucao);
        },

        evolucao (receita) { 
            this.$refs.evolucao.abrir(receita);
        },

        solicitar_matmed (receita, force_nova = false) { 
            let solicgeral = this.$util.get_solic_geral();

            if ( solicgeral ) { 

                receita.anamnese.atendimento_procedimento.atendimento.marcacao.nome_paciente = receita.anamnese.atendimento_procedimento.atendimento.paciente.st_nome;
                
                solicgeral.solicitar(
                    'S', 
                    { 
                        ...receita, 
                        data_aplic: this.referencia,
                        id_estoque_solicitacao: ( !force_nova && receita.solicitacao ) ? receita.solicitacao.id_estoque_solicitacao : null, 
                        marcacao: receita.anamnese.atendimento_procedimento.atendimento.marcacao
                    },
                    () => { 
                        this.load();
                    }
                );

            }
        },

        copiar_checagem(receita, horario) { 
            receita.items.forEach(item => { 
                if ( item.js_prescricao_horarios && item.js_prescricao_horarios.horarios ) { 
                    item.js_prescricao_horarios.horarios = item.js_prescricao_horarios.horarios.map(() => { 
                        return _.cloneDeep(horario);
                    });
                }
            });
        },

        stat_horarios (receita) { 
            return _.groupBy(
                receita.items.flatMap(item => item.js_prescricao_horarios ? item.js_prescricao_horarios.horarios : []),
                'status'
            );
        },

        checar (receita) {
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'checar',
                dados: receita,
                toast: true, 
                reload: true, 
                callback: () => { 
                    this.$emit('refresh');
                }
            });
        },

        cor_status (horario) { 
            if ( !horario && !horario.status )
                return;

            switch (horario.status) {
                case 'A': return 'fa fa-question-circle';
                case 'X': return 'fa fa-check-circle text-success';
                case 'R': return 'fa fa-exclamation-circle text-warning';
                case 'C': return 'fa fa-times-circle text-danger';
            }
        },

        cor_float_panel(horario) {

            if (!horario && !horario.status)
                return;

            switch (horario.status) {
                case 'A': return 'primary';
                case 'X': return 'success';
                case 'R': return 'warning';
                case 'C': return 'danger';
            }
        },

        aprazados(receita) {
            return receita.items.find(item => item.js_prescricao_horarios && item.js_prescricao_horarios.horarios.length) ? true : false;
        },

        incluir_horario (medic) { 
            if ( !medic.js_prescricao_horarios ) { 
                medic.js_prescricao_horarios = { 
                    horarios: [],
                };
            }

            for (let index = 0; index < this.qtde; index++) {
                
                medic.js_prescricao_horarios.horarios.push({ 
                    hora: "",
                    status: "A", 
                    obs: "",
                    responsavel_atualizacao: [{ st_nome: this.user.st_nome, id_pessoa: this.user.id_pessoa, dt_atualizacao: moment().format('YYYY-MM-DD HH:mm:ss') }]
                });

            }
        },

        aprazar (receita) { 
            this.item = _.cloneDeep(receita);

            this.$nextTick(() => { 
                $('#aprazamentoModal').modal('show');
            });
        },

        tratar_paciente (atendimento) { 
            return { 
                marcacao: atendimento
            };
        },

        tratar_procedimento (receita) { 
            return { 
                marcacao: { 
                    procedimento: receita.anamnese.atendimento_procedimento.procedimento,
                    medico: receita.anamnese.atendimento_procedimento.atendimento.medico, 
                }
            };
        },

        salvar_aprazamento () { 
            this.$util.atualizar(this, { 
                service: 'enfermagem',
                func: 'aprazar',
                dados: this.item,
                modal: 'aprazamentoModal',
                reload: true, 
            });
        },

        load(receita = null) { 
            let filtro = _.cloneDeep(this.filtro);

            if ( this.unica ) { 
                filtro.id_fila_laudo = null;
                filtro.id_medico = null;
                filtro.paciente = null;
                filtro.id_centro_custo = null;
                filtro.id_unidade_operacao = null; 
            }

            this.$util.load(this, { 
                service: 'enfermagem',
                func: 'aprazamentos',
                parms: { 
                    referencia: this.referencia, 
                    aprazados: true, 
                    lista_dias: true,
                    dieta: this.dieta ? true : false,  
                    ...filtro, 
                },
                loadTo: res => { 

                    if ( this.id_receita && res && res.lista && res.lista.length ) { 
                        res.lista = res.lista.filter(rec => { 
                            if ( this.id_receita ) { 
                                rec.exibido = true; 
                                return rec.id_receita == this.id_receita;
                            }

                            return true;
                        });
                    }

                    if ( receita && receita.id_receita && res && res.lista ) { 
                        let item = res.lista.find(rec => rec.id_receita == receita.id_receita);

                        if ( item ) { 
                            item.exibido = true; 
                        }
                    }

                    this.dados = res;
                }
            });
        },

        imprimirPrescricao (receita) { 
            this.$util.print_preview('imprimir/prescricao/' + receita.id_receita, false);
        },
        
        pode_assinar(receita) { 

            //return this.$store.state.user.medico ? true : false;

            //let id_medico;
            //let stateMedico = this.$store.state.user.medico;
            let receitaMedico = _.get(receita, 'anamnese.atendimento_procedimento.atendimento.medico');

            if(!receitaMedico) return false;

            return true;

            /*

            if ( !stateMedico && receitaMedico ) { 
                if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == receitaMedico.id_pessoa) ) { 
                    id_medico = receitaMedico.id_pessoa;
                }
            } else { 
                id_medico = this.$store.state.user.id_pessoa;
            }
           
            return receitaMedico.tem_certificado && receitaMedico.id_pessoa == id_medico;

            */
            
        },

        assinar(receita) {

            this.$refs.assinador.solicitar(
                'receita',
                receita.id_receita,
                () => { 
                this.load();
                },
                'prescricao_certificado'
            );
        },

        alterar_responsavel(horario) {
            console.log('alterar', this.$store.state.user);

            horario.responsavel_atualizacao = [
                    { 
                        st_nome: this.$store.state.user.pessoa.st_nome, 
                        id_pessoa: this.$store.state.user.pessoa.id_pessoa, 
                        dt_atualizacao: moment().format('YYYY-MM-DD HH:mm:ss'),
                        conselho: _.get(this.$store.state.user, 'medico.conselho.st_sigla', null), 
                        estado: _.get(this.$store.state.user, 'medico.estado_conselho.st_sigla', null), 
                        numero: _.get(this.$store.state.user, 'medico.in_numero_conselho', null), 
                    }
                ];
        },

        abrir_modal_documentos(receita) { 
            this.$refs.documentos.abrir_modal('receita', receita.id_receita, 'prescricao_certificado');
        },

        possibilidade_dupla_checagem(horario) {
            
            if (!horario.responsavel_atualizacao || horario.responsavel_atualizacao.length == 2 || horario.status != 'X' || !this.flDuplaChecagem) {
                return false;
            }

            if (!Array.isArray(horario.responsavel_atualizacao)) {
                return horario.responsavel_atualizacao != this.user.st_nome;
            }

            return !horario.responsavel_atualizacao.some(responsavel => responsavel.id_pessoa == this.user.id_pessoa);

        },

        dupla_checagem(horario) {
            if (!Array.isArray(horario.responsavel_atualizacao)) {
                horario.responsavel_atualizacao = [{ st_nome: horario.responsavel_atualizacao, id_pessoa: null, dt_atualizacao: null }];
            }

            horario.responsavel_atualizacao.push({ st_nome: this.user.st_nome, id_pessoa: this.user.id_pessoa, dt_atualizacao: moment().format('YYYY-MM-DD HH:mm:ss') });
        },

        tratar_status(horario) {
            
            const status = {
                A: 'Aberto',
                X: 'Checado',
                R: 'Rejeitado',
                C: 'Cancelado',
                Z: 'Reaprazado',
                S: 'Suspenso',
            };

            return status[horario.status];
        },

        formatar_dt_atualizacao(dtAtualizacao) {
            if(!dtAtualizacao) return '';
            return moment(dtAtualizacao).format('DD/MM/YYYY HH:mm:ss') 
        },

        tratar_abertura_mounted (res) { 

            this.filas = res

            if ( res && res.length == 1 ) { 
                this.filtro.id_fila_laudo = res[0].id_fila_laudo;
            }

        }
    },

    beforeMount() { 
        if ( this.$store.state.user.assist_id_medico ) { 
            
            this.filtro.id_medico = this.$store.state.user.assist_id_medico;

        } else if ( this.$store.state.user.medico 
            && this.$store.state.user.medico.conselho 
            && this.$store.state.user.medico.conselho.st_sigla != 'COREN' ) { 

            this.filtro.id_medico = this.$store.state.user.medico.id_pessoa;

        }

        this.filtro.id_fila_laudo = this.$util.getCookie('enfermagem-fila');

        this.chave = this.$util.uuidv4();
    },

    mounted() { 
        if ( !this.unica ) { 
            
            this.$store.commit("setBreadcrumb", [
                { name: "Assistência", path: "/assistencia/atend" },
                { name: "Aplicação", path: "/assistencia/aplic" },
            ]);

            this.load();

        }
        
        let parms = { 
            enfermagem: true, 
        };

        let chave_cache = 'enf';

        let info_cache = this.$store.state.options['filas_' + chave_cache]; 

        if ( info_cache ) { 

            this.tratar_abertura_mounted(info_cache);

            if ( this.$store.state.contexto['dupla-checagem-prescricao'] === true 
                || this.$store.state.contexto['dupla-checagem-prescricao'] === false  ) { 

                this.flDuplaChecagem = this.$store.state.contexto['dupla-checagem-prescricao'];

            } else { 

                let query = {
                    q: [
                    {
                        name: "configuracoes.check",
                        id: "dupla_checagem",
                        parms:  {
                        st_slug: "dupla-checagem-prescricao",
                        st_valor: "1",
                        }
                    }
                    
                    ]
                }

                this.axios.post('/aql', query)
                    .then(res => {
                
                        if(res.data.dupla_checagem.status == 200) {
                            this.flDuplaChecagem = res.data.dupla_checagem.data;
                            this.$store.commit('setContexto', { 'dupla-checagem-prescricao': res.data.dupla_checagem.data ? true : false });
                        }

                    }
                );

            }
            
        } else { 

            this.$util.loadItem(this, { 
                service: 'fila_laudos',
                func: 'index',
                parms: parms,
                configs: ['dupla-checagem-prescricao'],
            })
            .then(res => { 
                this.tratar_abertura_mounted(res); 
                this.$store.commit('setOptions', { name: 'filas_' + chave_cache, list: res });

                this.flDuplaChecagem = ( this.$store.state.contexto['dupla-checagem-prescricao'] == 1 ) ? true : false;
            });

        }        

    }
}
</script>
